import type { ExtensionConfig } from '@goto/shell-common'

export const extensionConfig: ExtensionConfig = {
  id: '@ucc/gtc-cc-qc-scorecard.evaluation',
  url: new URL('/experiences/cc-qm-scorecard-eval/goto-app-extension.js', location.origin),
  prerequisites: {
     ccFlags: 'cc-supervisor.quality-management-dashboard',
  },
  integrations: {
    msTeams: {
      shouldLoadInCompanion: true,
      shouldLoadInIntegration: true,
    },
    sidePanel: {
      shouldLoad: true,
    },
  }
}

export default extensionConfig

